import { IOrder } from 'shared/interfaces/order.interface';

export const initialStore = {
  reports: {
    timeframe: null,
    isLoadingTimeframe: true,
    isLoadingMomentary: true,
    momentary: {
      orders: null,
      orderStatusBreakdown: null
    }
  },
  patients: {
    dataPatients: [],
    isLoading: true,
    dataIndividualPatient: {
      isLoadingUpdate: false,
      data: null,
      orders: [] as IOrder[],
      payment: {
        paymentMethods: [],
        clientSecret: ''
      },
      address: null
    },
    count: 0
  },
  visits: {
    allVisits: null,
    countVisits: 0,
    isLoading: true,
    currentVisit: {
      data: null,
      paymentMethod: null,
      notes: []
    }
  },
  consultationsQueue: {
    isLoading: false,
    records: [],
    countRecords: 0
  },
  practitioners: {
    allPractitioners: null,
    isLoading: true
  },
  orders: {
    isLoading: true,
    countOrders: 0,
    data: [],
    currentTab: 'all',
    currentOrder: {
      data: null,
      paymentMethod: null,
      notes: [],
      visits: []
    },
    dataReport: []
  },
  labOrders: {
    isLoading: false,
    countLabOrders: 0,
    labOrders: [],
    currentTab: 'all',
    currentLabOrder: null
  },
  labPanels: {
    isLoading: false,
    labPanels: []
  },
  labs: {
    isLoading: false,
    labs: []
  },
  transactions: {
    isLoading: false,
    allTransactions: null,
    currentTransaction: {
      data: null,
      paymentMethod: null
    },
    countTransactions: 0
  },
  states: {
    allStates: null,
    isLoading: true
  },
  settings: {
    isLoading: true,
    currentUser: null,
    paymentMethod: {
      setupIntent: '',
      card: null,
      isLoading: true
    },
    affiliate: null,
    paymentProcessorsKeys: null
  },
  affiliateAdmins: {
    affiliateAdmins: [],
    isLoading: true
  },
  webhooks: {
    webhooksEvents: [],
    webhooks: [],
    isLoading: true
  },
  productVariations: {
    allProducts: [],
    isLoading: true,
    count: 0
  },
  subscriptionVariations: {
    allSubscriptions: [],
    isLoading: true,
    count: 0
  },
  products: {
    allProducts: [],
    isLoading: true
  },
  projects: {
    allProjects: [],
    isLoading: true
  },
  auth: {
    twoFactorType: null,
    twoFATypeOptions: {
      email: null,
      phone: null
    }
  },
  questionnaires: {
    allQuestionnaires: [],
    isLoading: true
  },
  pharmacies: {
    availablePharmacies: [],
    isLoading: false
  },
  communicationTemplates: {
    communicationTemplates: [],
    isLoading: false
  },
  noteTemplates: {
    noteTemplates: [],
    isLoading: false
  },
  chat: {
    isLoading: false,
    selectedConversation: null,
    data: null,
    totalUnreadMessages: 0,
    patientId: ''
  },
  supplies: {
    isLoading: false,
    pharmacySupplies: []
  },
  tags: {
    allTags: [],
    isLoading: false,
    error: null
  },
  journeyTemplate: {
    dataJourneyTemplates: [],
    isLoading: true,
    dataIndividualJourneyTemplate: {
      isLoadingUpdate: false,
      data: null
    },
    count: 0
  },
  product: {
    dataProducts: [],
    isLoading: false,
    dataIndividualProduct: {
      isLoadingUpdate: false,
      data: null
    },
    count: 0,
    dataProductVariations: {
      allProductsVariations: [],
      isLoading: true,
      count: 0
    }
  },
  subscription: {
    dataSubscriptions: { result: [], count: 0 },
    isLoading: false,
    dataIndividualSubscription: {
      isLoadingUpdate: false,
      data: null
    },
    count: 0
  },
  ecommerceOrder: {
    dataEcommerceOrders: { result: [], count: 0 },
    isLoading: false,
    dataIndividualEcommerceOrder: {
      isLoadingUpdate: false,
      data: null
    },
    count: 0,
    dataEcommerceOrderVariations: {
      allEcommerceOrderVariations: [],
      isLoading: false,
      count: 0
    },
    couponValidation: null,
    couponError: null,
    isCouponLoading: false,
    shareLinks: {},
    availablePaymentMethods: [],
    isLoadingPaymentMethods: false
  },
  ctrlCredentials: {
    isLoading: false,
    credential: {}
  },
  coupon: {
    dataCoupons: [],
    isLoading: true,
    dataIndividualCoupon: {
      isLoadingUpdate: false,
      data: null
    },
    count: 0
  }
};
